export default __webpack_public_path__ + "static/media/patient.1e1b865a.svg";